export const getHeaders = (accessToken: string) => ({
  Authorization: `Bearer ${accessToken}`,
});
